import type { SalesMetricType } from '@api';
import { formatDate, formatNumber } from '@common';
import type { EChartsCoreOption } from 'echarts/core';
import type { TFunction } from 'i18next';

const TRANS_PATH = 'TABLE.SALES_TIMELINE.TOOLTIP';

type SalesTimelineTooltipParamsType =
  | { dataIndex?: number }
  | Array<{ dataIndex?: number }>;

type GetTooltipOptionsArgsType = {
  salesTimeline: SalesMetricType[];
  t: TFunction<'ticketSales'>;
};

type GetTooltipOptionsReturnType = EChartsCoreOption['tooltip'];

export const getTooltipOptions = ({
  salesTimeline,
  t,
}: GetTooltipOptionsArgsType): GetTooltipOptionsReturnType => {
  return {
    trigger: 'axis',
    confine: true,
    formatter: (params: SalesTimelineTooltipParamsType) => {
      const items = Array.isArray(params) ? params : [params];
      const dataIndex = items[0]?.dataIndex;

      if (dataIndex === undefined) return '';

      const metric = salesTimeline[dataIndex];

      if (!metric) return '';

      return [
        formatDate(metric.date),
        `${t(`${TRANS_PATH}.TOTAL`)}: ${formatNumber(metric.salesTotal)}`,
        `${t(`${TRANS_PATH}.INCREASE`)}: ${formatNumber(metric.salesIncrease)}`,
      ].join('<br/>');
    },
  };
};
